module.exports = __webpack_public_path__ + "static/media/arrow.0dcc30e5.svg";